import { BnbIcon } from '@/assets/logo/bnb';
import { EthIcon } from '@/assets/logo/eth';
import { TronIcon } from '@/assets/logo/tron';
import { TranslogChain } from '@/lib/types/translog-chain.type';
import type { ComponentType } from 'react';

export type ChainMeta = {
  readonly chain: TranslogChain;
  readonly label: string;
  readonly short: string;
  readonly Icon: ComponentType<{ readonly className: string }>;
};

export const CHAINS: readonly ChainMeta[] = [
  { chain: TranslogChain.BNB, label: 'BNB Chain', short: 'BNB', Icon: BnbIcon },
  { chain: TranslogChain.ETH, label: 'Ethereum', short: 'ETH', Icon: EthIcon },
  { chain: TranslogChain.TRX, label: 'Tron', short: 'TRX', Icon: TronIcon },
];

export function getChainMeta(chain: TranslogChain): ChainMeta {
  return CHAINS.find((entry) => entry.chain === chain) ?? CHAINS[0];
}
